// extracted by mini-css-extract-plugin
export default {"notesContainer":"Notes_notesContainer__Vo++y"};